export const rules = {
  name: [{ required: true }],
};
